import BlankLayout from '@core/layouts/BlankLayout'

import TermsOfService from '~/auth/components/TermsOfService'
import Center from '~/components/Center'

export default function InterstitialPage() {
  return (
    <BlankLayout>
      <Center.Middle>
        <TermsOfService />
      </Center.Middle>
    </BlankLayout>
  )
}
